// extracted by mini-css-extract-plugin
export default {"value":"Value_value__a93Do"};